import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import { Icon } from "@iconify/react";
import { EditableInfoTooltip } from "./EditableInfoTooltip";
import { between } from "../style/style";
/**
 * Section header with an info icon that shows tooltip on hover.
 * Optionally supports an edit action (e.g. open modal for Reporting Contacts).
 */
export const SectionWithInfo = ({ title, tooltipText, children, onEdit, onTooltipSave, editableTooltip, variant = "default", titleProps, sx, }) => {
    const infoIcon = onTooltipSave != null ? (React.createElement(EditableInfoTooltip, { value: tooltipText, onSave: onTooltipSave, editable: editableTooltip !== null && editableTooltip !== void 0 ? editableTooltip : true, placeholder: "Edit Text...", ariaLabel: "Section information" })) : (React.createElement(Tooltip, { title: tooltipText, enterDelay: 300, placement: "top-start", arrow: true },
        React.createElement(Box, { component: "span", sx: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 20,
                height: 20,
                borderRadius: "50%",
                bgcolor: "info.lighter",
                color: "info.main",
                ml: 0.5,
                verticalAlign: "middle",
            }, "aria-label": "Section information" },
            React.createElement(Icon, { icon: "eva:info-outline", width: 14, height: 14 }))));
    if (variant === "bar") {
        return (React.createElement(Box, { sx: sx },
            React.createElement(Box, { onClick: onEdit, sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    py: 1,
                    px: 2,
                } },
                React.createElement(Box, { sx: { display: "flex", alignItems: "center" } },
                    React.createElement(Typography, { variant: "subtitle1", fontWeight: 600 }, title),
                    infoIcon),
                onEdit && (React.createElement(Icon, { icon: "solar:pen-outline", width: 20, height: 20 }))),
            children));
    }
    return (React.createElement(Box, { sx: sx },
        React.createElement(Box, { sx: Object.assign(Object.assign({}, between), { mb: 1 }) },
            React.createElement(Typography, Object.assign({ variant: "h5", color: "primary.darker" }, titleProps), title),
            infoIcon),
        children));
};
export default SectionWithInfo;
